import React, { useEffect, useState } from "react";
import { Row, Col, Form, Container } from "react-bootstrap";
import { connect } from "react-redux";
import { UploadDocumentTypeApi, GetDocumentTypeApi } from "./JobAction";
import { setHeading } from "../../../accounts/account.actions";
import { useParams, useNavigate } from "react-router-dom";
import { GlobalSpinner } from "../../../../../global/globalFunctions";
import _ from "lodash";
import Swal from "sweetalert";
import SendIcon from '@mui/icons-material/Send';
import Button from '@mui/material/Button';
import Select from "react-select";
import AddIcon from "@material-ui/icons/Add";
import RemoveIcon from "@material-ui/icons/Remove";
import API from "../../../../../global/api";


const AddDocumentType = (props) => {
    const navigate = useNavigate();
    const { jobId } = useParams();
    const emptyProduct = { productId: "", file: null };
    const [visibleAlert, setAlertVisible] = useState(false);
    const [dangerVisibleAlert, setDangerVisibleAlert] = useState(false);
    const [inputFieldProduct, setInputFieldProduct] = useState([emptyProduct]);


    const SaveJob = async () => {
        try {
            const finalPayload = [];
            for (let item of inputFieldProduct) {
                if (!item.productId || !item.file) {
                    throw new Error("Please select both document type and upload file.");
                }
                const formData = new FormData();
                formData.append("image", item.file);
                const res = await API.post("/files/image", formData, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                });
                const uploadedUrl = res?.data?.file;
                const selectedDocType = getDocumentList.find(doc => doc.value === item.productId);
                finalPayload.push({
                    documentTypeId: item.productId,
                    documentTypeName: selectedDocType?.label || "",
                    documentURL: uploadedUrl,
                });
            }

            await props.UploadDocumentTypeApi({
                jobId: jobId,
                documents: finalPayload,
            }, handleVisible, handleDangerVisible);

            await props.GetDocumentTypeApi();  // optional
            setInputFieldProduct([emptyProduct]);
        } catch (err) {
            handleDangerVisible(err.message || "Something went wrong");
        }
    };
    const handleVisible = (msg) => {
        setAlertVisible(true);
        navigate("/crm/job/ViewJob");
        setTimeout(() => {
            setAlertVisible(false);

        }, 2000);
        Swal({
            title: "Success",
            text: msg,
            icon: "success",
            button: "Ok",
        });
    };
    const handleDangerVisible = (err) => {
        setDangerVisibleAlert(true);
        setTimeout(() => {
            setDangerVisibleAlert(false);
        }, 9000);
        Swal({
            title: "Error",
            text: err,
            icon: "error",
            button: "Ok",
        });
    };

    const handleChangeProduct = (e, index, type) => {
        const list = [...inputFieldProduct];
        if (type === "intname") list[index]["productId"] = e.value;
        setInputFieldProduct(list);
    };

    const handleFileChange = (e, index) => {
        const list = [...inputFieldProduct];
        list[index].file = e.target.files[0];
        setInputFieldProduct(list);
    };
    const getDocumentList = props.documentTypeList?.length ? props.documentTypeList.map(x => ({
        value: x._id,
        label: `${x.documentName}`,
    })) : [];

    const handleAddInputProduct = () => {
        setInputFieldProduct([...inputFieldProduct, {
            productId: 0,
        }]);
    };
    const handleRemoveInputProduct = (index) => {
        const list = [...inputFieldProduct];
        list.splice(index, 1);
        setInputFieldProduct(list);
    };

    useEffect(() => {
        props.setHeading("Add Job");
        props.GetDocumentTypeApi();
    }, []);

    return (
        <>
            {props.isAddingDocumentType || props.isFetchingDocumentType || props.isFetchingJobWithId ? (
                <GlobalSpinner />
            ) : (<>

                <div style={{ width: '100%', backgroundColor: '#aed6ae', padding: '15px', borderRadius: '25px' }}>
                    <Row>
                        <Col style={{ marginBottom: '7px' }}><b style={{ fontSize: '17px', fontWeight: 'bold' }}>Job Number: <span style={{ fontSize: '15px', fontWeight: 'lighter' }}>{props.jobWithIdList?.sequenceNumber}</span> </b></Col>
                        <Col style={{ marginBottom: '7px' }}><b style={{ fontSize: '17px', fontWeight: 'bold' }}>Job Status: <span style={{ fontSize: '15px', fontWeight: 'lighter' }}>{props.jobWithIdList?.jobStatus}</span> </b></Col>
                        <Col style={{ marginBottom: '7px' }}><b style={{ fontSize: '17px', fontWeight: 'bold' }}>Job Date: <span style={{ fontSize: '15px', fontWeight: 'lighter' }}>{props.jobWithIdList?.startDate}</span> </b></Col>
                    </Row>
                    <Row>
                        <Col style={{ marginBottom: '7px' }}><b style={{ fontSize: '17px', fontWeight: 'bold' }}>Financial Year: <span style={{ fontSize: '15px', fontWeight: 'lighter' }}>{props.jobWithIdList?.financialYear}</span> </b></Col>
                        <Col style={{ marginBottom: '7px' }}><b style={{ fontSize: '17px', fontWeight: 'bold' }}>Job Fee: <span style={{ fontSize: '15px', fontWeight: 'lighter' }}>{props.jobWithIdList?.jobFee}</span> </b></Col>
                        <Col style={{ marginBottom: '7px' }}><b style={{ fontSize: '17px', fontWeight: 'bold' }}>Company Name: <span style={{ fontSize: '15px', fontWeight: 'lighter' }}>{props.jobWithIdList?.customerId?.companyName}</span> </b></Col>
                    </Row>
                    <Row>
                        <Col style={{ marginBottom: '7px' }}><b style={{ fontSize: '17px', fontWeight: 'bold' }}>Service Name: <span style={{ fontSize: '15px', fontWeight: 'lighter' }}>{props.jobWithIdList?.productId?.productName}</span> </b></Col>
                        <Col style={{ marginBottom: '7px' }}><b style={{ fontSize: '17px', fontWeight: 'bold' }}>Team Member: <span style={{ fontSize: '15px', fontWeight: 'lighter' }}>{props.jobWithIdList?.teamMemberId?.name}</span> </b></Col>
                        <Col></Col>
                    </Row>
                </div>

                <Container fluid>
                    <Form>
                        <Row>
                            <Col>
                                {inputFieldProduct.map((item, i) => {
                                    return (
                                        <React.Fragment key={i}>
                                            <Row>
                                                <Col>
                                                    <Form.Group className="mb-3" controlId="garana">
                                                        <Form.Label><b>Select Document Type *</b> </Form.Label>
                                                        <Select
                                                            placeholder="Select Document Type"
                                                            name="productId"
                                                            onChange={(e) => handleChangeProduct(e, i, "intname")}
                                                            options={getDocumentList}
                                                            value={getDocumentList.find(opt => opt.value === item.productId) || null}
                                                            isOptionDisabled={(option) => !_.isEmpty(_.find(inputFieldProduct, (x, idx) => idx !== i && x.productId === option.value))}
                                                        />
                                                    </Form.Group>
                                                </Col>
                                                <Col>
                                                    <Form.Group className="mb-3" controlId="garana">
                                                        <Form.Label><b>Upload Document *</b></Form.Label>
                                                        <Form.Control
                                                            placeholder="Upload Document"
                                                            type="file"
                                                            onChange={(e) => handleFileChange(e, i)}
                                                        />
                                                    </Form.Group>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col>
                                                    {inputFieldProduct.length - 1 == i && (
                                                        <Button title="Add Product" onClick={handleAddInputProduct} style={{ float: "right" }} >
                                                            <AddIcon />
                                                        </Button>
                                                    )}
                                                    {inputFieldProduct.length !== 1 && (
                                                        <Button title="Remove Product" onClick={() => handleRemoveInputProduct(i)} style={{ float: "right", marginRight: "1%" }}>
                                                            <RemoveIcon />
                                                        </Button>
                                                    )}
                                                </Col>
                                            </Row>
                                        </React.Fragment>)
                                })}
                            </Col>
                        </Row>

                        <div className="sendDiv">
                            <Button variant="contained" endIcon={<SendIcon />} size="large" onClick={SaveJob}> SAVE </Button>
                        </div>

                    </Form>
                </Container>
            </>)}
        </>
    );
};

const mapDispatchToProps = (dispatch) => {
    return {
        UploadDocumentTypeApi: (data, handleVisible, handleDangerVisible) => dispatch(UploadDocumentTypeApi(data, handleVisible, handleDangerVisible)),
        GetDocumentTypeApi: () => dispatch(GetDocumentTypeApi()),
        setHeading: (data) => dispatch(setHeading(data)),
    };
};
const mapStateToProps = (state, ownProps) => ({
    isAddingDocumentType: state.JobReducer.isAddingDocumentType,
    isFetchingDocumentType: state.JobReducer.isFetchingDocumentType,
    documentTypeList: state.JobReducer.documentTypeList,
    isFetchingJobWithId: state.JobReducer.isFetchingJobWithId,
    jobWithIdList: state.JobReducer.jobWithIdList,
});

export default connect(mapStateToProps, mapDispatchToProps)(AddDocumentType);